import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { useMemo } from "react";
import { getOperatorEmail, isOperatorMode } from "app/pages/Auth/authSelectors";
import OperatorWidget from "app/pages/.shared/OperatorWidget/OperatorWidget";
import { logout } from "app/pages/Auth/AuthActions";
import { bindActionCreators } from "redux";

const mapStateToProps = state => {
	return {
		operatorEmail: getOperatorEmail(state),
		isOperatorMode: isOperatorMode(state),
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({ logout }, dispatch);
};

const OperatorWidgetContainer = props => {
	const stateProps = useSelector(mapStateToProps, shallowEqual);
	const dispatch = useDispatch();
	const dispatchProps = useMemo(() => mapDispatchToProps(dispatch), [dispatch]);
	return <OperatorWidget {...props} {...stateProps} {...dispatchProps} />;
};

export default OperatorWidgetContainer;
